import React from 'react';
import { Spinner as ReactSpinner } from 'react-bootstrap';
import { AppState } from '../store/store';
import { connect } from 'react-redux';

interface SpinnerProps {
  small?: boolean;
}
export const Spinner = ({ loading, small }: Props) => {
  const size = small ? 'sm' : undefined;
  const className = small ? 'm-2' : 'm-5';
  if (!loading) {
    return null;
  }
  return (
    <ReactSpinner className={className} animation='border' role='status' size={size}>
      <span className='visually-hidden'>Loading...</span>
    </ReactSpinner>
  );
};

const mapStateToProps = ({ feedback }: AppState) => ({
  loading: feedback.loading,
});

type Props = ReturnType<typeof mapStateToProps> & SpinnerProps;

export default connect(mapStateToProps)(Spinner);
